// eslint-disable-next-line import/no-unresolved
import { breakpoints as themePrimary } from 'exo_theme_primary';
import { breakpoints } from './themeList';

const handler = {
  get: (target, prop) => {
    if (typeof window !== 'undefined' && window.exo_theme !== undefined) {
      return breakpoints[window.exo_theme][prop];
    }
    return target[prop];
  }
};

export default new Proxy(themePrimary, handler)
